import { FetchMiddleware, IFetchHandler, IMiddlewareConfig } from 'smarthub-common'
import {
  FetchCollection as Collection,
  coreFetchMiddleware as core,
  createFetchMiddleware as createMiddleware,
} from 'smarthub-core'

export const fetchMiddleware = (): IMiddlewareConfig<FetchMiddleware, IFetchHandler> => {
  const collection = new Collection()
  const middleware = createMiddleware(core, collection.middleware)
  return {
    middleware,
    collection,
  }
}
